import { FileType } from '../components/FileEntity';

const IMAGE_EXTENSIONS = new Set(['jpg', 'jpeg', 'png', 'gif', 'bmp', 'svg']);

export function getFileType(fileName: string): FileType {
  const extension = fileName.split('.').pop()?.toLowerCase();

  if (!extension) return 'other';

  if (extension === 'pdf') return 'pdf';

  if (IMAGE_EXTENSIONS.has(extension)) return 'image';

  if (
    [
      'js',
      'jsx',
      'ts',
      'tsx',
      'py',
      'java',
      'html',
      'css',
      'c',
      'cpp',
      'json',
      'xml',
    ].includes(extension)
  )
    return 'code';

  if (
    ['doc', 'docx', 'txt', 'rtf', 'md', 'xlsx', 'xls', 'ppt', 'pptx'].includes(
      extension,
    )
  )
    return 'document';

  return 'other';
}
